<template>
  <div>
    <div class="level is-mobile">
      <div class="level-left"></div>
      <div class="level-right">

        <div :class="`level-item has-text-centered ${hrBg}`">
          <div>
            <p class="title is-4 is-6-mobile">{{hours}}</p>
            <p class="is-size-7">hrs</p>
          </div>
        </div>

        <div :class="`level-item has-text-centered ${minBg}`">
          <div>
            <p class="title is-4 is-6-mobile">{{minutes}}</p>
            <p class="is-size-7">min</p>
          </div>
        </div>

        <div :class="`level-item has-text-centered ${secBg}`">
          <div class="p-0 p-1-tablet">
            <p class="title is-4 is-6-mobile">{{seconds}}</p>
            <p class="is-size-7">sec</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dateTime: Number,
  },
  data() {
    return {
      eventStarted: false,
      hours: null,
      minutes: null,
      seconds: null,
      interval: null,
      secBg: '',
      minBg: '',
      hrBg: ''
    }
  },
  mounted() {
    this.updateTime();

    this.interval = setInterval(() => {
      this.updateTime();
    }, 1000)
  },
  methods: {
    updateTime: function () {
      let cleanDate = new Date(this.dateTime);
      let freshDate = new Date().getTime();
      let endDate = cleanDate.getTime();
      let diff = endDate - freshDate;
      let hours = diff / (1000 * 60 * 60);
      let minutes = (hours % 1) * 60;
      let seconds = (minutes % 1) * 60;
      this.eventStarted = freshDate > this.dateTime;

      if (this.eventStarted) {
        this.hours = null;
        this.minutes = null;
        this.seconds = null;
        this.$emit('eventStarted');
        return clearInterval(this.interval);
      }

      let newMinutes = Math.floor(minutes).toString().padStart(2, '0');
      let minutesChanged = (newMinutes !== this.minutes) && this.minutes !== null;

      this.hours = Math.floor(hours).toString().padStart(2, '0');
      this.minutes = newMinutes;
      this.seconds = Math.floor(seconds).toString().padStart(2, '0');

      if (minutesChanged) {
        this.flashBg('sec');
        this.flashBg('min');
        this.flashBg('hr');
      }

    },
    toggleBg: function (hrMinOrSec) {
      let prop = hrMinOrSec + 'Bg';
      let currentBg = this[prop];
      if (currentBg) {
        return this[prop] = '';
      }

      return this[prop] = 'has-text-danger'//'has-background-danger-light';
    },
    flashBg: function (hrMinOrSec) {
      this.toggleBg(hrMinOrSec);

      setTimeout(() => {
        this.toggleBg(hrMinOrSec)
      }, 400);
    }
  },
  destroyed() {
    clearInterval(this.interval);
  }
}
</script>

<style scoped>
  .title {
    color: inherit;
  }
</style>